import React, { useMemo } from "react";
import { useGroupByContent } from "hooks";
import { ReportsQueries } from "../../../store/types";
import { AutocompleteMeasures } from "../Set-table-columns/AutocompleteMeasures";
import { difference } from "lodash";
import { calcFieldsToDisplay } from "constants/reports";

export type DataFormation = Partial<Pick<ReportsQueries, "measures" | "characteristics" | "calculatedFields">>;

interface SetTableColumnsProps {
  defaultQueries: Partial<ReportsQueries>;
  onChangeDataFormation?: (dataFormation: DataFormation) => void;
}

export const ReportSetTableColumns: React.FC<SetTableColumnsProps> = ({ defaultQueries, onChangeDataFormation }) => {
  const fields: Array<keyof ReportsQueries> = ["measures", "characteristics", "calculatedFields"];

  const { setFieldValue, values } = useGroupByContent({ fields, onChangeDataFormation, defaultQueries });

  const uniqueCalFieldsToShow = difference(values.calculatedFields, calcFieldsToDisplay);

  //feature is cut calculated fields from static toolbar from state of autocomplete
  const valuesCopy = useMemo(() => {
    const updatedValues = {
      ...values,
      calculatedFields: uniqueCalFieldsToShow
    };
    return updatedValues;
  }, [values, uniqueCalFieldsToShow]);

  return (
    <div className="set-table-columns">
      <div className="group-by-content__title"></div>
      <AutocompleteMeasures
        excludeStaticCalcFields
        label="Parameters"
        queries={valuesCopy}
        setQueryValue={setFieldValue}
      />
    </div>
  );
};
